module.exports = __webpack_public_path__ + "images/emoji/black_square_button.d3009f8d505331e463a6.png";